<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2021-12-19 17:08:44
 * @LastEditors: 诺
 * @LastEditTime: 2022-10-18 16:45:24
-->
<template>
  <div class="model" :style="{ backgroundColor: `${rgba(bColor, 0.3)}` }">
    <div class="modelTitle" :style="{ backgroundColor: bColor, color: textColor }">
      {{ title }}
    </div>
    <template v-for="(v, index) in list">
      <div :class="['modelBg', `modelBg${index}`]" v-if="v.prize.length != 0" :key="index">
        <div class="listTitle" :style="{ color: bColor }">{{ v.title }}</div>
        <div class="list first" v-if="firstItems(v)">
          <div class="item" v-for="(item, index) in firstItems(v)" :key="index">
            <div class="itemImg" :style="{ borderColor: bColor }">
              <img :src="item.img" />
            </div>
            <div class="name" :style="{ backgroundColor: bColor, color: textColor }">
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="list two" v-if="twoItems(v)">
          <div class="item" v-for="(item, index) in twoItems(v)" :key="index">
            <div class="itemImg" :style="{ borderColor: bColor }">
              <img :src="item.img" />
            </div>
            <div class="name" :style="{ backgroundColor: bColor, color: textColor }">
              <div :class="item.name .length>11?'name_animate':''" >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="list" v-if="items(v).length > 0">
          <div class="item" v-for="(item, index) in items(v)" :key="index">
            <div class="itemImg" :style="{ borderColor: bColor }">
              <img :src="item.img" />
            </div>
            <div class="name" :style="{ backgroundColor: bColor, color: textColor }">
              
              <div :class="item.name .length>9?'name_animate':''" >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import util from "./../../../utils/common";

export default {
  props: ["data", "bColor", "title", "textColor"],
  data() {
    return { list: [] };
  },
  created() {},
  methods: {
    rgba(color, alp) {
      return util.rgbToRgba(color, alp);
    },
    firstItems(item) {
      if (item.prize.length % 3 == 1) {
        return [item.prize[0]];
      }
    },
    twoItems(item) {
      if (item.prize.length % 3 == 2) {
        return [item.prize[0], item.prize[1]];
      }
    },
    items(item) {
      return item.prize.slice(item.prize.length % 3);
    },
  },
  computed: {
    modelBg() {
      return {
        background: this.btnBgColor,
        boxShadow: `0px 2px 3px ${this.btnBgColor}5c`,
      };
    },
  },
  filters: {},
  watch: {
    data: {
      handler(val) {
        let list = [];
        for (let i = 0; i < 6; i++) {
          let prize = val.filter((item) => {
            return item.groupId == i;
          });
          list.push({
            title: prize.length != 0 && prize[0].groupName,
            prize: prize,
          });
        }

        console.log(list);
        this.list = list;
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
div {
  box-sizing: border-box;
}

.model {
  width: 351px;
  margin: 32px auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-sizing: border-box;
  padding: 10px;

  .modelTitle {
    position: absolute;
    margin-top: -10px;
    color: white;
    padding: 0 20px;
    line-height: 40px;
    height: 40px;
    text-align: center;
    display: inline-block;
    font-size: 20px;
    font-weight: 600;
    border-radius: 0px 0px 12px 12px;
    z-index: 1;
  }

  .modelBg {
    width: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 7px;
    padding: 25px 10px 0;
    margin-bottom: 14px;
    .listTitle {
      font-weight: 600;
      font-size: 18px;
      color: #4870ff;
      text-align: center;
      margin-bottom: 16px;
    }

    .list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &.first {
        .item {
          width: 299px;
          .itemImg {
            width: 299px;
            height: 130px;
            img {
              width: 297px;
              height: 127px;
            }
          }
          .name {
            width: 100%;
          }
        }
      }

      &.two {
        .item {
          width: 144px;
          .itemImg {
            width: 144px;
            height: 100px;
            img {
              width: 142px;
              height: 97px;
            }
          }
          .name {
            width: 100%;
          }
        }
      }

      .item {
        border-radius: 4px;
        overflow: hidden;
        margin: 0 5px 12px;
        width: 93px;

        .itemImg {
          border-radius: 4px 4px 0 0;
          width: 93px;
          height: 93px;
          background-color: #f0f0f0;
          border-style: solid;
          border-width: 1px;

          img {
            border-radius: 2px 2px 0 0;
            width: 91px;
            height: 90px;
            object-fit: contain;
          }
        }

        .name {
          border-radius: 0 0 4px 4px;
          width: 100%;
          font-weight: normal;
          font-size: 11px;
          line-height: 20px;
          color: white;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 0 2px;
        }
      }
    }
  }
  .modelBg0 {
    padding-top: 40px;
  }
  .modelBg:last-child {
    margin-bottom: 0;
  }
}
.name_animate{
  animation: marquee_animate 10s infinite linear;
}
    
@keyframes marquee_animate {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>
